import { BubbleMenu, Editor } from '@tiptap/react'

import { useStaticIntl } from '../../../../i18n/index.js'
import { MenuMultiOptionItem } from '../../../components/BubbleMenuSelectItem.js'
import { videoSizeOptionsGenerator } from '../utils.js'

export const VideoMenu = ({ editor }: { editor: Editor }) => {
  const videoSizeOptions = useStaticIntl(videoSizeOptionsGenerator)

  return (
    <BubbleMenu
      pluginKey="video-bubble-menu"
      shouldShow={({ editor }) => {
        return editor.isActive('video')
      }}
      editor={editor}
      tippyOptions={{
        delay: 0,
        arrow: true,
        placement: 'bottom',
        moveTransition: 'transform 0.2s ease-out',
        appendTo: 'parent',
        offset: [0, 5],
        maxWidth: '100vw',
        /**
         *  The return type of this function is void | false, hence being impossible
         *  to enforce consistent return.
         */
        // eslint-disable-next-line consistent-return
        onHide(_) {
          /**
           * This callback prevents a bug in Safari where opening a dropdown in the
           * video options (e.g. size) would cause the component to hide prematurely and
           * the dropdown to appear in top-left corner of the screen.
           * There's still an issue where closing the popover while the dropdown is active
           * would cause the dropdown to flash to the top, but this is an edge case, and is caused
           * by the dropdown component being rendered in a portal, outside the popover component tree.
           */

          if (editor.isActive('video')) {
            return false
          }
        },
      }}
    >
      <div className="rounded-sm divide-y divide-line-subdued text-content-subdued bg-surface shadow-lg border border-line-subdued">
        <div className="overflow-auto flex items-center divide-x divide-line-subdued py-1">
          <MenuMultiOptionItem
            className="mx-1"
            title="Video Menu"
            options={videoSizeOptions}
            editor={editor}
          />
        </div>
      </div>
    </BubbleMenu>
  )
}
